(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["partial_announcement-bar"] && !Shopify.designMode) return;
  try {
    
  if($('.marquee').length) {
    Marquee3k.init({
      selector: 'marquee',
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["template_product"]) return;
  try {
    
  window.addEventListener('DOMContentLoaded', () => {
    const selectors = ['.matching-items', '.related-products-container'];
    selectors.forEach(selector => {
      const section = document.querySelector(selector);
      if (!section) return;
      const url = section.dataset.url;
      if (!url) return;
      fetch(url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const replacement = html.querySelector(selector);
          if (replacement && replacement.innerHTML.trim().length) {
            section.innerHTML = replacement.innerHTML;
          }
        })
        .catch(e => {
          console.error(e);
        });
    });

    // Handle size specs option clicks
    const sizeSpecsOptions = document.querySelectorAll('.size-specs-option');
    const sizeSpecsImages = document.querySelectorAll('.size-specs-image');
    
    // Function to set active option and image
    function setActiveOption(option) {
      const targetClass = option.dataset.target;
      
      // Remove active class from all options and images
      sizeSpecsOptions.forEach(opt => {
        opt.classList.remove('active');
      });
      sizeSpecsImages.forEach(image => {
        image.classList.remove('active');
      });
      
      // Add active class to selected option
      option.classList.add('active');
      
      // Add active class to the specific target image
      const targetImage = document.querySelector(`.${targetClass}`);
      if (targetImage) {
        targetImage.classList.add('active');
      }
    }
    
    // Set first option as active by default
    if (sizeSpecsOptions.length > 0) {
      setActiveOption(sizeSpecsOptions[0]);
    }
    
    sizeSpecsOptions.forEach(option => {
      option.addEventListener('click', () => {
        setActiveOption(option);
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
